import React from "react";
import "./Tokenomics.scss";
import Button from "../../components/shared/Button";

import TokenomicsImg1 from "../../assets/images/tokenomics-1.png";
import TokenomicsImg2 from "../../assets/images/tokenomics-2.png";

import TotalSupplyIcon from "../../assets/images/total-supply-icon.svg";
import TransactionFeeIcon from "../../assets/images/transaction-fee-icon.svg";

import GridImg from "../../assets/images/hex-grid.png";

export default function Roadmap() {
	return (
		<>
			<div className="tokenomics" id="tokenomics">
				<div className="decoration tokenomics-light-1"></div>
				<img
					className="decoration tokenomics-grid-bg"
					src={GridImg}
					alt="Grid"
				/>
				<img
					className="decoration tokenomics-img-1"
					src={TokenomicsImg1}
					alt="Tokenomics"
				/>
				<img
					className="decoration tokenomics-img-2"
					src={TokenomicsImg2}
					alt="Tokenomics"
				/>

				<div className="tokenomics-content-wrapper content-wrapper-lg">
					<h3 className="tokenomics-small-title">Tokenomics</h3>
					<h2 className="tokenomics-title">$AUR Token</h2>

					<div className="tokenomics-card">
						<div className="decoration gradient-bg"></div>
						<div className="decoration noise-bg"></div>

						<div className="tokenomics-info">
							<ul className="tokenomics-info-items">
								<li className="tokenomics-info-item">
									<div className="info-title">
										<img
											className="info-title-icon"
											src={TotalSupplyIcon}
											alt="Total Supply"
										/>
										Total Supply:
									</div>
									<div className="info-value">
										100,000,000 $AUR Tokens
									</div>
								</li>
								<li className="tokenomics-info-item">
									<div className="info-title">
										<img
											className="info-title-icon"
											src={TransactionFeeIcon}
											alt="Transaction Fee"
										/>
										Transaction Fee:
									</div>
									<div className="info-value">
										5% Buy/Sell
									</div>
								</li>
							</ul>
						</div>

						<div className="tokenomics-btn">
							<Button className="details-btn" href="https://aur-ai.gitbook.io/aurai/tokenomics/distribution">
								View Details
							</Button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
